import microOrgs from '@/sui/data/microOrgs'
import modules from '@/sui/data/modules'
import rtti from '@/sui/tools/rtti'
import pdf from '@/sui/tools/pdf'
import color from 'color'

const base = '#0a77a7'
const alphaBase = `${base}84`
function pieChart (title, labels, datasets, filter) {
  return {
    options: {
      title: {
        display: true,
        text: title,
        fontColor: base,
        fontSize: 14
      },
      cutoutPercentage: 50,
      legend: {
        position: 'bottom',
        fullWidth: false,
        labels: {
          fontColor: base,
          fontSize: 10,
          filter: filter,
          boxWidth: 10
        }
      },

      plugins: {
        datalabels: {
          backgroundColor: color('white').fade(0.3).hsl().string(),
          borderRadius: 3,
          borderColor: alphaBase,
          color: base,
          font: {
            style: 'bold'
          },

          display: function (context) {
            const index = context.dataIndex
            const value = context.dataset.data[index]
            return value > 0
          },
          offset: 0
        }
      }
    },
    data: {
      labels: labels,
      datasets: datasets
    }
  }
}

function charts (stats) {
  let div = color('#FF9C2D')
  const colors = [
    div.string()
  ]
  for (let i = 0; i !== 11; ++i) {
    colors.push(div.rotate((i + 1) * 3).rgb().string())
  }
  const other = color('#9774CC').darken(0.1)
  for (let i = 0; i !== 12; ++i) {
    colors.push(other.rotate((i + 1) * 8).rgb().string())
  }
  colors.push('#9774CC')
  colors.push('#87FFA1')

  const labels = [
    'Bactériémies sur DIV',
    'CVC',
    'CCI',
    'CVO',
    'PICC line',
    'MID line',
    'CVP court',
    'Dialyse',
    'Autre cathéter',
    'Fistule native',
    'Fistule prothèse',
    'Dialyse péritonéale',
    'Cathéter sous-cutané',
    'Cutanée',
    'Site opératoire',
    'Pleuro-plumonaire',
    'Urinaire',
    'Digestive / abdominale',
    'Translocation digestive',
    'Materno-foetale',
    'Méningite',
    'Endocardite',
    'Ostéo-articulaire',
    'Autre',
    `Autres portes d'entrée`,
    `Portes d'entrée non retrouvées`
  ]

  return [
    {
      key: 'repartition',
      type: 'doughnut',
      exportConfig: [
        {
          label: 'Taille de la police sur les sections (px)',
          options: { numeral: true },
          key: 'font-size',
          default: 12,

          toConfig: function (value) {
            const v = value == null ? 12 : parseInt(value)
            return {
              plugins: {
                datalabels: {
                  font: {
                    size: v
                  }
                }
              }
            }
          }
        },
        {
          label: `Afficher les noms des portes d'entrée`,
          type: 'checkbox',
          key: 'show-entrances',
          default: 1,

          toConfig: function (value) {
            if (value) {
              return {
                plugins: {
                  datalabels: {
                    formatter: function (value, context) {
                      if (context.datasetIndex !== 1) {
                        return value
                      }

                      return `${labels[context.dataIndex]}: ${value}`
                    }
                  }
                }
              }
            }
            return {}
          }
        }
      ],
      config: pieChart(
        `Répartition des bactériémies par porte d'entrée`,
        labels,
        [
          {
            fill: true,
            borderColor: 'white',
            borderWidth: 2,
            backgroundColor: colors,
            data: stats.repartition
          },
          {
            fill: true,
            borderColor: 'white',
            borderWidth: 2,
            backgroundColor: colors,
            data: stats.details
          }
        ],
        function (legendItem, chartData) {
          return legendItem.index === 0 || legendItem.index >= 24
        }
      )
    },
    {
      key: 'bacteria',
      type: 'doughnut',
      exportConfig: [
        {
          label: 'Taille de la police sur les sections (px)',
          options: { numeral: true },
          key: 'font-size',
          default: 8,

          toConfig: function (value) {
            const v = value == null ? 12 : parseInt(value)
            return {
              plugins: {
                datalabels: {
                  font: {
                    size: v
                  }
                }
              }
            }
          }
        },
        {
          label: `Afficher le détail`,
          type: 'checkbox',
          key: 'show-legend',
          default: 2,

          toConfig: function (value) {
            if (value) {
              return {
                layout: {
                  padding: {
                    left: 80,
                    right: 80,
                    top: 0,
                    bottom: 0
                  }
                },
                plugins: {
                  datalabels: {
                    formatter: function (v, context) {
                      if (context.datasetIndex !== 0) {
                        return v
                      }

                      return `${v} ${moCategories[context.dataIndex].label}`
                    },

                    align: function (context) {
                      if (context.datasetIndex !== 0) {
                        return 'middle'
                      }

                      return 'end'
                    },

                    anchor: function (context) {
                      if (context.datasetIndex !== 0) {
                        return 'center'
                      }

                      return 'end'
                    }
                  }
                }
              }
            }
            return {}
          }
        }
      ],
      config: pieChart(
        `Répartition des bactériémies par germe`,
        moCategoriesLabels,
        [
          {
            fill: true,
            borderColor: 'white',
            borderWidth: 2,
            backgroundColor: moColors,
            data: stats.microOrgsDetail
          },
          {
            fill: true,
            borderColor: 'white',
            borderWidth: 2,
            backgroundColor: moColors,
            data: stats.microOrgs
          }
        ],
        function (legendItem, chartData) {
          return stats.microOrgs[legendItem.index] > 0
        }
      )
    }
  ]
}
function isDivEntrance (entrance) {
  return entrance <= 6 || (entrance >= 8 && entrance <= 12)
}

function entrancePosition (entrance) {
  if (entrance <= 6) {
    return entrance
  }
  if (entrance === 7) {
    return 12
  }
  if (entrance <= 12) {
    return entrance - 1
  }

  if (entrance === 24) {
    return 25
  }

  return entrance
}

function reaInfEntrancePosition (e) {
  let result = 24
  if (e <= 4) {
    result = e
  } else if (e === 5) {
    result = 8
  } else if (e === 6) {
    result = 23
  }

  return entrancePosition(result)
}

function moIndex (code) {
  const item = microOrgs.completeList.find(m => m.code === code)
  return item.index
}

function codeLambda (code) {
  return (c) => c === moIndex(code)
}

function codeFilter (label, code, color) {
  return {
    label: label,
    filter: codeLambda(code),
    color: color
  }
}

function codeDetailFilter (label, code) {
  return {
    label: label,
    detail: codeLambda(code)
  }
}

function resFilters (label, filter, type) {
  const result = []
  const rType = microOrgs.resistances.find(r => r.field === type)
  rType.values.forEach(
    r => {
      result.push(
        {
          label: `${label}${r.code}`,
          detail: (c, a) => {
            if (!filter(c)) {
              return false
            }

            const value = a.find(v => v.code === rType.index)
            return value.resistance === r.index
          }
        }
      )
    }
  )
  return result
}

const enterobacteriaIndex = []
microOrgs.enterobacteria.forEach(
  mo => {
    enterobacteriaIndex.push(moIndex(mo))
  }
)
const candidaIndex = []
microOrgs.candida.forEach(
  mo => {
    candidaIndex.push(moIndex(mo))
  }
)

function listLambda (list) {
  return (c) => {
    return list.indexOf(c) !== -1
  }
}

function enterobacteriaFilters () {
  let result = []
  microOrgs.enterobacteria.forEach(
    e => {
      result = result.concat(
        ...resFilters(
          `${e} C3G=`, codeLambda(e), 'c3g'
        )
      )
    }
  )

  return result
}

const moCategories = [
  codeFilter('Staphylococcus aureus', 'STA AUR', '#FFE81F'),
  ...resFilters('STA AUR OXA=', codeLambda('STA AUR'), 'oxa'),
  {
    label: 'Staphylocoques à coagulase négative',
    filter: (c) => c > 0 && c < 6,
    color: '#FEBAE4'
  },
  codeDetailFilter('STA EPI', 'STA EPI'),
  codeDetailFilter('STA HAE', 'STA HAE'),
  codeDetailFilter('STA CAP', 'STA CAP'),
  codeDetailFilter('STA AUT', 'STA AUT'),
  codeDetailFilter('STA NSP', 'STA NSP'),
  {
    label: 'Entérocoques',
    filter: (c) => c > 11 && c < 16,
    color: '#78FFC2'
  },
  ...resFilters('ENC FAE GLY=', codeLambda('ENC FAE'), 'gly'),
  ...resFilters('ENC FAI GLY=', codeLambda('ENC FAI'), 'gly'),
  {
    label: 'Autres entérocoques',
    detail: (c) => c === 14 || c === 15
  },
  {
    label: 'Entérobactéries',
    filter: listLambda(enterobacteriaIndex),
    color: '#7065FF'
  },
  ...enterobacteriaFilters(),
  codeFilter('Pseudomonas aeruginosa', 'PSE AER', '#FF6654'),
  ...resFilters('PSE AER CARB=', codeLambda('PSE AER'), 'car'),
  codeFilter('Acinetobacter baumannii', 'ACI BAU', '#77FF67'),
  ...resFilters('ACI BAU CARB', codeLambda('ACI BAU'), 'car'),
  {
    label: 'Candida et levures',
    filter: listLambda(candidaIndex),
    color: '#FEF1D9'
  },
  ...resFilters('CAN et LEV FLU=', listLambda(candidaIndex), 'flu'),
  {
    label: 'Autres',
    filter: () => true,
    detail: () => true,
    color: '#CCCCCC'
  }
]

const moCategoriesLabels = []
const moMainCategories = []
const moColors = []
let current = color('black')
let step = 0
for (let i = 0; i !== moCategories.length; ++i) {
  const c = moCategories[i]
  if (c.filter != null) {
    moMainCategories.push(i)
  }
  if (c.color) {
    current = color(c.color)
    step = 1
    moColors.push(current.darken(0.1).rgb().string())
  } else {
    const rotation = step++ % 10
    const light = step / 10 % 4
    moColors.push(current.darken(light * 0.1).rotate(-rotation * 7).rgb().string())
  }
  moCategoriesLabels.push(c.label)
}

class MicroCounter {
  constructor (categories) {
    this.categories = categories
    this.detail = new Array(categories.length).fill(0)
    this.repartition = new Array(categories.length).fill(0)
  }

  add (m) {
    const count = this.categories.length
    let df = false
    let rf = false
    for (let i = 0; !(df && rf) && i !== count; ++i) {
      const cat = this.categories[i]
      if (!rf && cat.filter != null && cat.filter(m.code)) {
        ++this.repartition[i]
        rf = true
      }

      if (!df && cat.detail != null && cat.detail(m.code, m.antibio)) {
        ++this.detail[i]
        df = true
      }
    }
  }
}

class FieldCounter {
  constructor (fields) {
    this.fields = fields
    this.counter = {}
    this.fields.forEach(
      f => {
        this.counter[f.field] = null
      }
    )
  }

  add (sheet) {
    this.fields.forEach(
      f => {
        let values = rtti.isString(f.field) ? sheet[f.field] : f.field(sheet)
        if (values != null) {
          if (!rtti.isArray(values)) {
            values = [values]
          }

          values.forEach(
            v => {
              switch (f.type) {
                case 'mean':
                  this.addMean(f, v)
                  break
                default:
                  this.addCounter(f, v)
              }
            }
          )
        }
      }
    )
  }

  addCounter (f, v) {
    let c = this.counter[f.field]
    if (c == null) {
      this.counter[f.field] = {
        label: f.title,
        counters: {},
        total: 1
      }
      c = this.counter[f.field]
    } else {
      c.total++
    }

    if (c.counters[v] == null) {
      c.counters[v] = {
        count: 1,
        label: f.labels[v]
      }
    } else {
      c.counters[v].count++
    }
  }

  addMean (f, v) {
    let c = this.counter[f.field]
    if (c == null) {
      this.counter[f.field] = {
        label: f.title,
        sum: v,
        total: 1,
        type: 'mean',
        unit: f.unit,
        fixed: f.fixed
      }
      c = this.counter[f.field]
    } else {
      c.total++
      c.sum += v
    }
  }

  toValues (f) {
    const result = [
      {
        label: 'Effectif',
        count: f.total
      }
    ]

    if (f.type === 'mean') {
      const mean = (f.sum / f.total).toFixed(f.fixed)
      const unit = f.unit != null ? f.unit : ''
      result.push(
        {
          label: 'Moyenne',
          count: `${mean}${unit}`
        }
      )
    } else {
      for (let i in f.counters) {
        const c = f.counters[i]
        const p = (100 * c.count / f.total).toFixed(1)
        result.push(
          {
            label: c.label,
            count: c.count,
            percentage: `${p}%`
          }
        )
      }
    }
    return result
  }

  toDetails () {
    const result = []
    for (let f in this.counter) {
      const c = this.counter[f]
      if (c != null) {
        result.push(
          {
            key: `field-${f}`,
            title: c.label,
            values: this.toValues(c)
          }
        )
      }
    }
    return result
  }
}

const modules2019 = modules['2019']

export default {
  diaInfADI: {
    stats: function (list) {
      const patients = list.length
      const repartition = new Array(26).fill(0)
      const details = new Array(26).fill(0)
      const micro = new MicroCounter(moCategories)
      const fields = new FieldCounter(modules2019.diaInfADI.stats.fields)
      let infections = 0

      let count = 0
      for (let i in list) {
        const lb = list[i].f.bacteremias
        fields.add(list[i].f)
        for (let j in lb) {
          const b = lb[j]
          if (isDivEntrance(b.entrance)) {
            ++repartition[0]
          }
          if (b.entrance !== 8) {
            ++details[entrancePosition(b.entrance)]
          } else {
            ++details[entrancePosition(12)]
          }

          b.microOrganisms.forEach(
            m => {
              micro.add(m)
            }
          )

          ++count
        }
        const lc = list[i].f.catheters
        for (let j in lc) {
          const c = lc[j]
          const li = c.infections
          for (let k in li) {
            const inf = li[k]
            if (inf.infection === 2) {
              inf.microOrganisms.forEach(
                m => {
                  micro.add(m)
                }
              )

              ++count
              if (c.type === 1) {
                ++details[entrancePosition(10)]
              } else if (c.type === 2) {
                ++details[entrancePosition(11)]
              } else {
                ++repartition[0]
                ++details[entrancePosition(8)]
              }
            } else {
              ++infections
            }
          }

          if (c.type === 4) {
            ++repartition[0]
            ++details[entrancePosition(c.type)]
            ++count
          }
        }
      }
      repartition[24] = count - repartition[0] - details[25]
      repartition[25] = details[25]
      return {
        infections: infections,
        patients: patients,
        count: count,
        divCount: repartition[0],
        repartition: repartition,
        details: details,
        microOrgs: micro.repartition,
        microOrgsDetail: micro.detail,
        fields: fields
      }
    },

    details: function (stats) {
      return [
        {
          key: 'patients',
          title: 'Patients',
          values: [{ label: 'Effectif', count: `${stats.patients}` }]
        },
        {
          key: 'bact',
          title: 'Bactériémies',
          values: [{ label: 'Effectif', count: `${stats.count}` }]
        },
        {
          key: 'bact-div',
          title: 'Bactériémies sur dispositif intra-vasculaire',
          values: [{ label: 'Effectif', count: `${stats.divCount}` }]
        },
        {
          key: 'infections',
          title: 'Infections',
          values: [{ label: 'Effectif', count: `${stats.infections}` }]
        },
        ...stats.fields.toDetails()
      ]
    },

    charts: charts
  },

  neoInfADI: {
    stats: function (list) {
      const patients = list.length
      const repartition = new Array(26).fill(0)
      const details = new Array(26).fill(0)
      const micro = new MicroCounter(moCategories)
      const fields = new FieldCounter(modules2019.neoInfADI.stats.fields)
      let sepsis = 0

      let count = 0
      for (let i in list) {
        const lb = list[i].f.bacteremias
        fields.add(list[i].f)
        sepsis += list[i].f.sepsis.length
        for (let j in lb) {
          const b = lb[j]
          if (isDivEntrance(b.entrance)) {
            ++repartition[0]
          }
          ++details[entrancePosition(b.entrance)]
          ++count
          b.microOrganisms.forEach(
            m => {
              micro.add(m)
            }
          )
        }
        const lc = list[i].f.catheters
        for (let j in lc) {
          const c = lc[j]
          if (c.isColIlcBlcSep === 4) {
            ++repartition[0]
            const position = c.type === 1 ? 1 : 3
            ++details[entrancePosition(position)]
            ++count
            c.microOrganisms.forEach(
              m => {
                micro.add(m)
              }
            )
          }
        }
      }
      repartition[24] = count - repartition[0] - details[25]
      repartition[25] = details[25]
      return {
        sepsis: sepsis,
        patients: patients,
        count: count,
        divCount: repartition[0],
        repartition: repartition,
        details: details,
        microOrgs: micro.repartition,
        microOrgsDetail: micro.detail,
        fields: fields
      }
    },

    details: function (stats) {
      return [
        {
          key: 'patients',
          title: 'Patients',
          values: [{ label: 'Effectif', count: `${stats.patients}` }]
        },
        {
          key: 'bact',
          title: 'Bactériémies',
          values: [{ label: 'Effectif', count: `${stats.count}` }]
        },
        {
          key: 'bact-div',
          title: 'Bactériémies sur dispositif intra-vasculaire',
          values: [{ label: 'Effectif', count: `${stats.divCount}` }]
        },
        {
          key: 'sepsis',
          title: 'Sepsis',
          values: [{ label: 'Effectif', count: `${stats.sepsis}` }]
        },
        ...stats.fields.toDetails()
      ]
    },

    charts: charts
  },

  reaInfADI: {
    stats: function (list) {
      const patients = list.length
      const repartition = new Array(26).fill(0)
      const details = new Array(26).fill(0)
      const micro = new MicroCounter(moCategories)
      const fields = new FieldCounter(modules2019.reaInfADI.stats.fields)

      let count = 0
      let pneu = 0
      for (let i in list) {
        fields.add(list[i].f)
        pneu += list[i].f.pneumopathies.length
        const lb = list[i].f.bacteremias
        for (let j in lb) {
          const b = lb[j]
          if (isDivEntrance(b.entrance)) {
            ++repartition[0]
          }
          ++details[entrancePosition(b.entrance)]
          ++count
          b.microOrganisms.forEach(
            m => {
              micro.add(m)
            }
          )
        }
        const lc = list[i].f.catheters
        for (let j in lc) {
          const c = lc[j]
          if (c.isColIlcBlc === 4) {
            ++repartition[0]
            ++details[reaInfEntrancePosition(c.type)]
            ++count
            c.microOrganisms.forEach(
              m => {
                micro.add(m)
              }
            )
          }
        }
      }
      repartition[24] = count - repartition[0] - details[25]
      repartition[25] = details[25]
      return {
        patients: patients,
        count: count,
        divCount: repartition[0],
        repartition: repartition,
        details: details,
        pneu: pneu,
        microOrgs: micro.repartition,
        microOrgsDetail: micro.detail,
        fields: fields
      }
    },

    details: function (stats) {
      return [
        {
          key: 'patients',
          title: 'Patients',
          values: [{ label: 'Effectif', count: `${stats.patients}` }]
        },
        {
          key: 'bact',
          title: 'Bactériémies',
          values: [{ label: 'Effectif', count: `${stats.count}` }]
        },
        {
          key: 'bact-div',
          title: 'Bactériémies sur dispositif intra-vasculaire',
          values: [{ label: 'Effectif', count: `${stats.divCount}` }]
        },
        {
          key: 'pneu',
          title: 'Pneumopathies',
          values: [{ label: 'Effectif', count: `${stats.pneu}` }]
        },
        ...stats.fields.toDetails()
      ]
    },

    charts: charts
  },

  reaBactADI: {
    stats: function (list) {
      const patients = list.length
      const repartition = new Array(26).fill(0)
      const details = new Array(26).fill(0)
      const micro = new MicroCounter(moCategories)
      const fields = new FieldCounter(modules2019.reaBactADI.stats.fields)
      let count = 0
      for (let i in list) {
        const lb = list[i].f.bacteremias
        fields.add(list[i].f)
        for (let j in lb) {
          const b = lb[j]
          if (isDivEntrance(b.entrance)) {
            ++repartition[0]
          }
          ++details[entrancePosition(b.entrance)]
          ++count
          b.microOrganisms.forEach(
            m => {
              micro.add(m)
            }
          )
        }
      }
      repartition[24] = count - repartition[0] - details[25]
      repartition[25] = details[25]
      return {
        patients: patients,
        count: count,
        divCount: repartition[0],
        repartition: repartition,
        details: details,
        microOrgs: micro.repartition,
        microOrgsDetail: micro.detail,
        fields: fields
      }
    },

    details: function (stats) {
      return [
        {
          key: 'patients',
          title: 'Patients',
          values: [{ label: 'Effectif', count: `${stats.patients}` }]
        },
        {
          key: 'bact',
          title: 'Bactériémies',
          values: [{ label: 'Effectif', count: `${stats.count}` }]
        },
        {
          key: 'bact-div',
          title: 'Bactériémies sur dispositif intra-vasculaire',
          values: [{ label: 'Effectif', count: `${stats.divCount}` }]
        },
        ...stats.fields.toDetails()
      ]
    },

    charts: charts
  },

  bactADI: {
    stats: function (list) {
      const count = list.length
      const repartition = new Array(26).fill(0)
      const details = new Array(26).fill(0)
      const micro = new MicroCounter(moCategories)
      const fields = new FieldCounter(modules2019.bactADI.stats.fields)

      for (let i in list) {
        const b = list[i].f.bacteremia
        fields.add(list[i].f)
        if (isDivEntrance(b.entrance)) {
          ++repartition[0]
        }
        ++details[entrancePosition(b.entrance)]
        b.microOrganisms.forEach(
          m => {
            micro.add(m)
          }
        )
      }
      repartition[24] = count - repartition[0] - details[25]
      repartition[25] = details[25]
      return {
        count: count,
        divCount: repartition[0],
        repartition: repartition,
        details: details,
        microOrgs: micro.repartition,
        microOrgsDetail: micro.detail,
        fields: fields
      }
    },

    details: function (stats) {
      return [
        {
          key: 'bact',
          title: 'Bactériémies',
          values: [{ label: 'Effectif', count: stats.count }]
        },
        {
          key: 'bact-div',
          title: 'Bactériémies sur dispositif intra-vasculaire',
          values: [{ label: 'Effectif', count: stats.divCount }]
        },
        ...stats.fields.toDetails()
      ]
    },

    charts: charts
  },

  exportPDF (vm) {
    const styles = {
      h1: {
        fontSize: 20,
        color: '#0b89c0'
      },

      h2: {
        fontSize: 14,
        margin: [0, 20, 0, 5],
        color: '#0b89c0'
      },

      std: {
        color: '#0b89c0'
      },

      columnHeader: {
        fontSize: 8
      },

      center: {
        alignment: 'center'
      },

      value: {
        alignment: 'right'
      },

      bold: {
        bold: true
      }
    }

    const year = `${vm.surveillance.year}`
    const title = `${vm.surveillance.establishment.name} - SPIADI ${year}`
    const subtitle = `${vm.moduleName}`
    const content = [
      { text: title, style: 'h1' }
    ]

    const filter = []
    vm.filters.uf.forEach(
      (uf, i) => {
        const first = i === 0
        const last = i === vm.filters.uf.length - 1
        const sep = first ? ' pour les services ' : last ? ' et ' : ', '
        filter.push(
          {
            text: [
              { text: `${sep}${uf.uf}`, style: [ 'bold', 'std' ] },
              { text: `(${uf.unitTypeCode})`, style: 'std' }
            ]
          }
        )
      }
    )
    const body = [
      [
        {
          text: [
            {
              text: `Statistiques - ${subtitle}`,
              style: 'h2'
            },
            {
              text: filter
            }
          ],
          colSpan: 4
        },
        {},
        {},
        {}
      ]
    ]

    const widths = ['*', '*', 35, 35]

    vm.details.forEach(
      d => {
        const labels = []
        const values = []
        const percentages = []
        d.values.forEach(
          v => {
            labels.push(v.label)
            values.push(
              { text: `${v.count}`, style: ['bold', 'value'] }
            )
            percentages.push(
              v.percentage ? { text: v.percentage, style: 'value' } : ' '
            )
          }
        )
        const line = [d.title, labels, values, percentages]
        body.push(line)
      }
    )

    content.push(
      {
        fontSize: 9,
        layout: {
          hLineWidth: function (i, node) {
            return i < 1 ? 0 : 1
          },

          vLineWidth: function (i, node) {
            return 0
          },

          hLineColor: function (i, node) {
            return 'gray'
          },

          paddingLeft (i) {
            return i === 0 ? 0 : 1
          },

          paddingRight (i, node) {
            return (i < node.table.widths.length - 1) ? 1 : 0
          }
        },
        table: {
          dontBreakRows: true,
          widths: widths,
          body: body
        }
      }
    )
    const definition = {
      pageStyle: 'A4',
      content: content,
      styles: styles,
      footer: (current, count) => {
        return {
          text: `${title} - ${subtitle} page ${current}/${count}`,
          fontSize: 6,
          alignment: 'center'
        }
      }
    }
    const filename = `${title} - ${vm.moduleName} - Statistiques.pdf`
    pdf.createPdf(definition).download(filename)
  },

  select: {
    show: false,
    list: [],
    callback: null,

    reset: function () {
      this.list = []
      this.callback = null
      this.show = false
    },

    showModal: function (callback) {
      this.show = true
      this.callback = callback
    },

    hide: function (msg) {
      this.show = false
      if (msg === 'ok' && this.callback != null) {
        this.callback(this.list)
      }
    },

    none: function () {
      this.list = []
    },

    selected: function (u) {
      return this.list.indexOf(u) !== -1
    },

    toggle: function (u) {
      const index = this.list.indexOf(u)
      if (index === -1) {
        this.list.push(u)
        return true
      }

      this.list.splice(index, 1)
      return false
    }
  }
}
